import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import sidenavReducer from './sideNavSlice'
import userReducer from './userSlice'

export default configureStore({
  reducer: { sidenav: sidenavReducer, user: userReducer },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
})